import React from 'react';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import Link from '../../components_common/Link/Link';
import { mailTo } from '../../helpers';
import { customerCareEmail } from '../../helpers/emailAddresses';
import BrowseSubtitle from './styled/BrowseSubtitle';
import { Wrapper } from '../../components_desktop/css_global/utils.css';

const BrowseFooter = () => (
  <Wrapper textAlign="center">
    <BrowseSubtitle>Need help?</BrowseSubtitle>
    <VerticalSpacer height="5px" />
    Contact us at <Link href={mailTo(customerCareEmail)}>customercare@italist.com</Link>
  </Wrapper>
);

export default BrowseFooter;
